import axios from "axios";

const REPORT_BASE_URL = "https://unit60.smartekanban.in/index.php/Apiv7";

const ApiService = {
  // 🔹 Fetch lines
  async getLines() {
    try {
      const response = await axios.get(`${REPORT_BASE_URL}/get_lines`);
      if (response.data.status && Array.isArray(response.data.line_no)) {
        return response.data.line_no;
      }
      return [];
    } catch (error) {
      console.error("Error fetching lines:", error);
      return [];
    }
  },

  // 🔹 Fetch operations
  async getOperations() {
    try {
      const response = await axios.get(`${REPORT_BASE_URL}/get_tls_operations`);
      if (response.data.status && Array.isArray(response.data.data)) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error("Error fetching operations:", error);
      return [];
    }
  },

  // 🔹 Fetch master operations count (POST FormData)
// async getMasterOperationsCount(line_no, op_id) {
//   try {
//     const formData = new FormData();
//     formData.append("line_no", line_no);

//     // ✅ Append op_id only if user selected it
//     if (op_id && op_id !== undefined && op_id !== null && op_id !== "") {
//       formData.append("op_id", op_id);
//     }

//     console.log("📦 Payload sent to API:", Object.fromEntries(formData.entries()));

//     const response = await axios.post(
//       `${REPORT_BASE_URL}/get_master_operations_count`,
//       formData
//     );
//     return response.data;
//   } catch (error) {
//     console.error("❌ Error fetching master operations:", error);
//     return null;
//   }
// },

  async getMasterOperationsCount(line_no, op_id = "", date = "") {
  try {
    const formData = new FormData();
    formData.append("line_no", line_no);

    // ✅ Append op_id only if user selected it
    if (op_id && op_id !== undefined && op_id !== null && op_id !== "") {
      formData.append("op_id", op_id);
    }

    // ✅ Append date (default: today)
    if (date && date !== undefined && date !== null && date !== "") {
      formData.append("date", date);
    } else {
      formData.append(
        "date",
        new Date().toISOString().split("T")[0] // default today
      );
    }

    console.log(
      "📦 Payload sent to API:",
      Object.fromEntries(formData.entries())
    );

    const response = await axios.post(
      `${REPORT_BASE_URL}/get_master_operations_count`,
      formData
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error fetching master operations:", error);
    return null;
  }
},

  async getSiteTitle() {
  try {
    const response = await axios.get(`${REPORT_BASE_URL}/get_site_title`);
    if (response.data.status) {
      return response.data.title;
    }
    return "Site Title Not Found";
  } catch (error) {
    console.error("Error fetching site title:", error);
    return "Site Title Not Found";
  }
},

// 🔹 Fetch Device List (Operation Types)
async getDevices() {
  try {
    const response = await axios.post(`${REPORT_BASE_URL}/get_devices`);
    if (response.data.status) {
      return response.data.data.devices;
    }
    return [];
  } catch (error) {
    console.error("Error fetching devices:", error);
    return [];
  }
},

 async getOperationsWithMaster(from_date, to_date, device_id = null) {
    try {
      const formData = new FormData();
      formData.append("from_date", from_date);
      formData.append("to_date", to_date);

      // ✅ Only append if valid (not null, undefined, or empty)
      if (device_id && device_id !== "null" && device_id !== "undefined") {
        formData.append("device_id", device_id);
      }

      const response = await axios.post(
        `${REPORT_BASE_URL}/get_operations_with_master`,
        formData
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching operations with master:", error);
      return null;
    }
  },  async getOperationsFilter(from_date, to_date, device_id = null) {
    try {
      const formData = new FormData();
      formData.append("from_date", from_date);
      formData.append("to_date", to_date);

      // ✅ Append only if user selected a device
      if (device_id && device_id !== "" && device_id !== "All") {
        formData.append("device_id", device_id);
      }

      console.log(" Sending payload to API:", Object.fromEntries(formData.entries()));

      const response = await axios.post(
        `${REPORT_BASE_URL}/get_operations_filter`,
        formData
      );

      return response.data;
    } catch (error) {
      console.error(" Error fetching operations filter:", error);
      return null;
    }
  }, 
  async getOperationsFilter(from_date, to_date, device_id = null) {
    try {
      const formData = new FormData();
      formData.append("from_date", from_date);
      formData.append("to_date", to_date);

      if (device_id && device_id !== "" && device_id !== "All") {
        formData.append("device_id", device_id);
      }

      const response = await axios.post(
        `${REPORT_BASE_URL}/get_operations_filter`,
        formData
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching operations filter:", error);
      return null;
    }
  },
  async getHourlyDeviceCount(line_no, date) {
  try {
    const formData = new FormData();
    formData.append("line_no", line_no);
    formData.append("date", date);

    const response = await axios.post(
      `${REPORT_BASE_URL}/get_hourly_device_count`,
      formData
    );

    if (response.data.status && response.data.data) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error(" Error fetching hourly device count:", error);
    return null;
  }
},
};




export default ApiService;
